import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import DefaultLayoutMobile from '@/layouts/DefaultLayoutMobile'
import PrintLayout from '@/layouts/PrintLayout'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta:{order: 1},
    component: DefaultLayout,
    redirect: '/pages/login',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta:{order: 2},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import('@/views/Dashboard.vue'),
      },
  
      {
        path: '/change-password',
        name: 'Change Password',
        meta:{order: 2},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/ChangePassword.vue'
          ),
      },
      // Orders
      {
        path: '/order-processing/all-orders',
        meta:{order: 2},
        name: 'Orders',
        component: () =>
          import('@/views/warehouse/order_processing/Orders.vue'),
      },
      // Manage
      {
        path: '/manage/getting-started',
        meta:{order: 2},
        name: 'Getting started',
        component: () => import('@/views/warehouse/manage/GettingStarted.vue'),
      },
      {
        path: '/manage/barcodes',
        meta:{order: 2},
        name: 'Barcodes',
        component: () => import('@/views/warehouse/manage/Barcodes.vue'),
      },
      {
        path: '/manage/warehouse',
        meta:{order: 2},
        name: 'Manage Warehouse',
        component: () => import('@/views/warehouse/manage/Warehouse.vue'),
      },
      {
        path: '/manage/zone',
        meta:{order: 2},
        name: 'Manage Zone',
        component: () => import('@/views/warehouse/manage/Zone.vue'),
      },
      {
        path: '/manage/aisle-rack-shelf',
        meta:{order: 2},
        name: 'Manage Aisle, Rack and Shelf locations',
        component: () =>
          import('@/views/warehouse/manage/AisleRackShelfLocation.vue'),
      },
      {
        path: '/financial-dashboard',
        name: 'Financial Dashboard',
        meta: { order: 2 },
        component: () =>
          import('@/views/financial-portal/financial-dashboard.vue'),
      },
      {
        path: '/manage/credit-note',
        meta: { order: 2 },
        name: 'Manage Credit Notes',
        component: () =>
          import('@/views/warehouse/manage/CreditNote.vue'),
      },
      {
        path: '/manage/bills-and-reports',
        meta: { order: 2 },
        name: 'Manage Bills & Reports',
        component: () =>
          import('@/views/financial-portal/bills/index.vue'),
      },
      {
        path: '/inbound/create-bill',
        name: 'CreateBill',
        component: () => import('@/views/financial-portal/bills/create-bill.vue'),
      },
      {
        path: '/inbound/bill-edit/:id',
        name: 'EditBill',
        component: () => import('@/views/financial-portal/bills/create-bill.vue'),
      },
      {
        path: '/manage/settings',
        meta: { order: 2 },
        name: 'Settings',
        component: () =>
          import('@/views/financial-portal/settings.vue'),
      },
      {
        path: '/manage/sales-register',
        meta: { order: 2 },
        name: 'Manage Sales Register',
        component: () =>
          import('@/views/financial-portal/sales-register/sales-register.vue'),
      },
      {
        path: '/manage/sales-register/add-new',
        meta: {order: 2},
        name: 'Add New Sales Register',
        component: () => import('@/views/financial-portal/sales-register/AddSalesRegister.vue')
      },
      {
        path: '/manage/sales-register/edit/:id',
        meta: { order: 2 },
        name: 'Edit Sales Register',
        component: () =>
          import('@/views/financial-portal/sales-register/AddSalesRegister.vue'),
      },
      {
        path: '/manage/expense-register',
        meta: { order: 2 },
        name: 'Manage Expense Register',
        component: () =>
          import('@/views/financial-portal/expense-register/index.vue'),
      },
      {
        path: '/manage/expense-register/add-new',
        meta: { order: 2 },
        name: 'Add New Expense Register',
        component: () => import('@/views/financial-portal/expense-register/expense-add-form.vue')
      },
      {
        path: '/manage/expense-register/edit/:id',
        meta: { order: 2 },
        name: 'Edit Expense Register',
        component: () => import('@/views/financial-portal/expense-register/expense-add-form.vue')
      },
      {
        path: '/manage/finance-register',
        meta: { order: 2 },
        name: 'Manage Finance Register',
        component: () =>
          import('@/views/financial-portal/finance-register/index.vue'),
      },
      {
        path: '/manage/finance-register/add-new',
        meta: { order: 2 },
        name: 'Add New Finance Register',
        component: () => import('@/views/financial-portal/finance-register/finance-add-form.vue')
      },
      {
        path: '/manage/finance-register/edit/:id',
        meta: { order: 2 },
        name: 'Edit Finance Register',
        component: () => import('@/views/financial-portal/finance-register/finance-add-form.vue')
      },
      {
        path: '/manage/trolley-bin',
        meta:{order: 2},
        name: 'Manage Trolley & Bin',
        component: () => import('@/views/warehouse/manage/TrolleyBin.vue'),
      },
      {
        path: '/manage/users',
        meta:{order: 2},
        name: 'Manage Users',
        component: () => import('@/views/warehouse/manage/Users.vue'),
      },
      {
        meta:{order: 2},
        path: '/manage/billing/',
        name: 'Manage Billing',
        component: () => import('@/views/warehouse/manage/Billing.vue'),
      },
      {
        path: '/manage/billing/:id',
        meta:{order: 3},
        name: 'Billing List',
        component: () => import('@/views/warehouse/manage/BillingDetail.vue'),
      },
      {
        path: '/manage/quotations',
        meta:{order: 2},
        name: 'Manage Quotations',
        component: () => import('@/views/warehouse/manage/Quotation.vue'),
      },
      {
        path: "/manage/error-logs",
        meta:{order: 2},
        name: "Error Logs",
        component: () => import('@/views/warehouse/manage/ShopifyErrors.vue'),
      },

      {
        meta:{order: 2},
        path: '/manage/custom-invoices',
        name: 'Manage Custom Invoices',
        component: () => import('@/views/warehouse/manage/CustomInvoices.vue'),
      },
      {
        meta:{order: 2},
        path: '/manage/vendors',
        name: 'Manage Vendors',
        component: () => import('@/views/adminportal/manage/Vendors.vue'),
      },
      {
        meta:{order: 2},
        path: '/manage/reports',
        name: 'Reports',
        component: () => import('@/views/warehouse/manage/reports.vue'),
      },
      {
        meta:{order: 3},
        path: '/manage/vendors/:id',
        name: 'Vendor Details',
        component: () => import('@/views/adminportal/manage/VendorDetails.vue'),
      },
      {
        meta:{order: 2},
        path: '/manage/contracts',
        name: 'Contracts',
        component: () => import('@/views/warehouse/manage/Contracts.vue'),
      }

      /////////////////////////////////////////////////////////////////////////
      ////////////////////////////////////////////////////////////////////////
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'forgot-password',
        name: 'Forgot Password',
        component: () => import('@/views/pages/forgotPassword'),
      },
      {
        path: 'reset-password/:id',
        name: 'Reset Password',
        component: () => import('@/views/pages/resetPassword'),
      },
      // {
      //   path: 'print-barcode',
      //   name: 'Print Barcode',
      //   component: () => import('@/views/warehouse/manage/PrintBarcodes.vue'),
      // },
    ],
  },
  {
    path: '/print',
    name: 'Print area',
    component: PrintLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'invoice',
        name: 'Print invoice',
        component: () => import('@/views/warehouse/print/Invoice.vue'),
      },
      {
        path: 'shipping-label',
        name: 'Shipping label',
        component: () => import('@/views/warehouse/print/ShippingLabel.vue'),
      },
      {
        path: 'sku-barcode',
        name: 'Print SKU barcode',
        component: () => import('@/views/warehouse/print/SKUs.vue'),
      },
      {
        path: 'artefact-barcode',
        name: 'Print barcode',
        component: () => import('@/views/warehouse/print/Barcodes.vue'),
      },
      {
        path: 'order-view',
        name: 'View Order',
        component: () => import('@/views/warehouse/print/OrderView.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
